
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30168',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30168",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54354",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7956",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11401",
  "I18n": "static-7.1610",
  "quartz": "static-1.6940",
  "quartz-config": "static-1.718",
  "quartz-core": "static-1.6159",
  "react-dlb": "static-1.77",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.778",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54341",
  "feedback-utils": "static-1.54345",
  "forms-embed-utils-lib": "static-1.4402",
  "forms-utils-lib": "static-1.12461",
  "foundations-assets": "static-1.4793",
  "foundations-components": "static-1.7808",
  "foundations-theming": "static-1.4356",
  "hub-http": "static-1.6162",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11709",
  "icons": "static-2.643",
  "immutable": "static-2.77",
  "quick-fetch": "static-1.3868",
  "raven": "static-3.5829",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16603",
  "react-select-plus": "static-1.103",
  "react-utils": "static-2.5295",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.485",
  "tinymce-plugins": "static-1.57295",
  "transmute": "static-2.85",
  "ui-images": "static-2.1138",
  "UIComponents": "static-3.8348",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9542",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3355",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3217",
  "quartz-webpack": "static-1.3164",
  "foundations-theming-specialty": "static-1.2072",
  "property-description-translator": "static-1.3789",
  "HeadJS": "static-2.740",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3067",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4266",
  "jasmine-runner": "static-1.6411",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.826",
  "hubspotter-http": "static-1.4603",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.615",
  "quartz-head": "static-1.605",
  "quartz-i18n": "static-1.615",
  "quartz-routing": "static-1.370",
  "quartz-test": "static-1.615",
  "quartz-tracking": "static-1.319",
  "ui-fonts": "static-1.663",
  "usage-tracker-container": "static-1.7268",
  "usage-tracker-core": "static-1.7128",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7190",
  "reference-resolvers": "static-1.8111",
  "sanitize-text": "static-1.8084",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10313",
  "sanitize": "static-1.4414",
  "outpost": "static-1.4131",
  "rpc-client-utils": "static-1.4587",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4077",
  "floating-ui": "static-1.54",
  "hs-story-utils": "static-1.9370",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1630",
  "bend-plugin-foundations-theming": "static-1.2839",
  "foundations-theming-base": "static-1.3341",
  "stylex": "static-1.31",
  "hs-locale-management": "static-1.35",
  "csstype": "static-1.50",
  "ai-components-ui-library": "static-1.8774",
  "atom": "static-1.5013",
  "codemirror": "static-5.93",
  "content-assistance-lib": "static-1.7655",
  "ContentUtils": "static-1.68166",
  "data-token-picker": "static-1.16293",
  "file-manager-components": "static-1.23432",
  "FileManagerCore": "static-1.38931",
  "FileManagerLib": "static-1.39072",
  "frontend-preferences-client": "static-1.7868",
  "hub-http-contrib": "static-1.2981",
  "interframe": "static-3.4702",
  "layout-dnd-components": "static-1.12321",
  "layout-dnd-utils": "static-1.11296",
  "property-translator": "static-1.5344",
  "react-codemirror": "static-1.10565",
  "react-colorpicker": "static-2.10152",
  "reference-resolvers-lite": "static-1.8034",
  "rich-text-lib": "static-1.19721",
  "tinymce-data": "static-1.40266",
  "tinymce-themes": "static-1.56151",
  "ui-addon-emoji-picker": "static-1.9829",
  "ui-addon-sales-email": "static-1.5151",
  "ui-brand-identity-lib": "static-1.14957",
  "bender-build-tools": "static-1.3093",
  "hub-http-shared-msw-handlers": "static-1.9816",
  "hubspotter-http-shared-msw-handlers": "static-1.9814",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4964",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "chirp-fetch": "static-1.1826",
  "chatspot-core": "static-1.20976",
  "copilot-toolkit": "static-1.10949",
  "customer-data-objects-ui-components": "static-1.12963",
  "data-fetching-client": "static-1.9615",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4708",
  "ui-addon-video-player": "static-1.8639",
  "ui-coaching-tips": "static-1.28358",
  "usage-tracker": "static-1.7278",
  "cms-field-types": "static-1.4752",
  "content-icons-ui": "static-1.2211",
  "integrations-lib": "static-1.15899",
  "customer-data-objects": "static-1.7601",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4590",
  "apollo-stack-hubspot": "static-3.84",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "immerable": "static-1.4095",
  "ui-addon-iframeable": "static-1.8994",
  "video-components-external": "static-1.11055",
  "video-data-lib": "static-1.34713",
  "audio-components": "static-1.5819",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29184",
  "FileManagerImages": "static-1.36583",
  "foundations-components-legacy": "static-1.833",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.523",
  "ui-universal-auth": "static-1.8899",
  "urlinator": "static-1.4473",
  "video-components": "static-1.13058",
  "video-embed": "static-1.35547",
  "ts-schema": "static-1.4029",
  "ContentData": "static-1.68241",
  "layout-data-lib": "static-1.9621",
  "react-dnd-compat": "static-1.4560",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1492",
  "external-options-client-types": "static-1.4110",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6818",
  "hs-promise-utils": "static-1.5534",
  "inbound-db-properties-service-client": "static-1.3793",
  "NamespacedHubStyle": "static-2.9015",
  "growth-onboarding-confetti": "static-1.3009",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11092",
  "amplitude-session-replay-browser": "static-1.58",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5521",
  "magpie-types": "static-1.4981",
  "simple-logging-lib": "static-1.2990",
  "avatar-components": "static-1.2437",
  "customer-data-ui-utilities": "static-1.9767",
  "growth-onboarding-feedback-components": "static-1.6525",
  "flux-actions": "static-1.329",
  "hubspot-apollo-client": "static-1.4818",
  "integrations-error-boundary-lib": "static-1.13314",
  "integrations-tracking-lib": "static-1.5537",
  "laboratory-lib": "static-3.7100",
  "native-integrations-shared-strings": "static-1.7725",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10089",
  "unified-auth": "static-1.413",
  "navigation-messaging": "static-1.7133",
  "content-media-composition-data-lib": "static-1.12033",
  "content-media-compositions": "static-2.16040",
  "idb-keyval": "static-1.42",
  "media-bridge-lib": "static-1.18816",
  "unified-auth-core-lib": "static-1.694",
  "social-insights-client-types": "static-1.21892",
  "advanced-menus-core": "static-1.15029",
  "advanced-menus-lib": "static-1.11983",
  "ExportDialog": "static-6.10334",
  "ui-memberships-settings-lib": "static-1.33861",
  "conditional-properties-service-client": "static-1.3748",
  "crm-pipelines-api-client-types": "static-1.4094",
  "framework-builder-read-service-client": "static-1.3961",
  "framework-data-schema-quick-fetch": "static-1.6723",
  "inbound-db-meta-service-client": "static-1.3542",
  "multi-currency-client-types": "static-1.3643",
  "persist-promise": "static-1.3649",
  "foundations-components-test-utils": "static-1.5291",
  "reactive-lib": "static-1.662",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.277",
  "universal-page-editor-lib": "static-1.2951",
  "google-sheets-integration-lib": "static-1.41",
  "microsoft-drive-integration-lib": "static-1.141",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3674",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15028",
  "simple-menus-lib": "static-1.16545",
  "crm-record-cards-service-types": "static-1.3562",
  "location-customization-utils-lib": "static-1.9041",
  "react-flip-move": "static-1.68"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30168",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54354",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7956",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11401",
  "I18n": "/I18n/static-7.1610",
  "quartz": "/quartz/static-1.6940",
  "quartz-config": "/quartz-config/static-1.718",
  "quartz-core": "/quartz-core/static-1.6159",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.778",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54341",
  "feedback-utils": "/feedback-utils/static-1.54345",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4402",
  "forms-utils-lib": "/forms-utils-lib/static-1.12461",
  "foundations-assets": "/foundations-assets/static-1.4793",
  "foundations-components": "/foundations-components/static-1.7808",
  "foundations-theming": "/foundations-theming/static-1.4356",
  "hub-http": "/hub-http/static-1.6162",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11709",
  "icons": "/icons/static-2.643",
  "immutable": "/immutable/static-2.77",
  "quick-fetch": "/quick-fetch/static-1.3868",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16603",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-utils": "/react-utils/static-2.5295",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tinymce-plugins": "/tinymce-plugins/static-1.57295",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1138",
  "UIComponents": "/UIComponents/static-3.8348",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9542",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3355",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3217",
  "quartz-webpack": "/quartz-webpack/static-1.3164",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2072",
  "property-description-translator": "/property-description-translator/static-1.3789",
  "HeadJS": "/HeadJS/static-2.740",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3067",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4266",
  "jasmine-runner": "/jasmine-runner/static-1.6411",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "hubspotter-http": "/hubspotter-http/static-1.4603",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.615",
  "quartz-head": "/quartz-head/static-1.605",
  "quartz-i18n": "/quartz-i18n/static-1.615",
  "quartz-routing": "/quartz-routing/static-1.370",
  "quartz-test": "/quartz-test/static-1.615",
  "quartz-tracking": "/quartz-tracking/static-1.319",
  "ui-fonts": "/ui-fonts/static-1.663",
  "usage-tracker-container": "/usage-tracker-container/static-1.7268",
  "usage-tracker-core": "/usage-tracker-core/static-1.7128",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7190",
  "reference-resolvers": "/reference-resolvers/static-1.8111",
  "sanitize-text": "/sanitize-text/static-1.8084",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10313",
  "sanitize": "/sanitize/static-1.4414",
  "outpost": "/outpost/static-1.4131",
  "rpc-client-utils": "/rpc-client-utils/static-1.4587",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4077",
  "floating-ui": "/floating-ui/static-1.54",
  "hs-story-utils": "/hs-story-utils/static-1.9370",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1630",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2839",
  "foundations-theming-base": "/foundations-theming-base/static-1.3341",
  "stylex": "/stylex/static-1.31",
  "hs-locale-management": "/hs-locale-management/static-1.35",
  "csstype": "/csstype/static-1.50",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8774",
  "atom": "/atom/static-1.5013",
  "codemirror": "/codemirror/static-5.93",
  "content-assistance-lib": "/content-assistance-lib/static-1.7655",
  "ContentUtils": "/ContentUtils/static-1.68166",
  "data-token-picker": "/data-token-picker/static-1.16293",
  "file-manager-components": "/file-manager-components/static-1.23432",
  "FileManagerCore": "/FileManagerCore/static-1.38931",
  "FileManagerLib": "/FileManagerLib/static-1.39072",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7868",
  "hub-http-contrib": "/hub-http-contrib/static-1.2981",
  "interframe": "/interframe/static-3.4702",
  "layout-dnd-components": "/layout-dnd-components/static-1.12321",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11296",
  "property-translator": "/property-translator/static-1.5344",
  "react-codemirror": "/react-codemirror/static-1.10565",
  "react-colorpicker": "/react-colorpicker/static-2.10152",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8034",
  "rich-text-lib": "/rich-text-lib/static-1.19721",
  "tinymce-data": "/tinymce-data/static-1.40266",
  "tinymce-themes": "/tinymce-themes/static-1.56151",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9829",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5151",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14957",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9816",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9814",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4964",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "chirp-fetch": "/chirp-fetch/static-1.1826",
  "chatspot-core": "/chatspot-core/static-1.20976",
  "copilot-toolkit": "/copilot-toolkit/static-1.10949",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12963",
  "data-fetching-client": "/data-fetching-client/static-1.9615",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4708",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8639",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28358",
  "usage-tracker": "/usage-tracker/static-1.7278",
  "cms-field-types": "/cms-field-types/static-1.4752",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "integrations-lib": "/integrations-lib/static-1.15899",
  "customer-data-objects": "/customer-data-objects/static-1.7601",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4590",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4095",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8994",
  "video-components-external": "/video-components-external/static-1.11055",
  "video-data-lib": "/video-data-lib/static-1.34713",
  "audio-components": "/audio-components/static-1.5819",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29184",
  "FileManagerImages": "/FileManagerImages/static-1.36583",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.833",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.523",
  "ui-universal-auth": "/ui-universal-auth/static-1.8899",
  "urlinator": "/urlinator/static-1.4473",
  "video-components": "/video-components/static-1.13058",
  "video-embed": "/video-embed/static-1.35547",
  "ts-schema": "/ts-schema/static-1.4029",
  "ContentData": "/ContentData/static-1.68241",
  "layout-data-lib": "/layout-data-lib/static-1.9621",
  "react-dnd-compat": "/react-dnd-compat/static-1.4560",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1492",
  "external-options-client-types": "/external-options-client-types/static-1.4110",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6818",
  "hs-promise-utils": "/hs-promise-utils/static-1.5534",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3793",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9015",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3009",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11092",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5521",
  "magpie-types": "/magpie-types/static-1.4981",
  "simple-logging-lib": "/simple-logging-lib/static-1.2990",
  "avatar-components": "/avatar-components/static-1.2437",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9767",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6525",
  "flux-actions": "/flux-actions/static-1.329",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4818",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13314",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5537",
  "laboratory-lib": "/laboratory-lib/static-3.7100",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7725",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10089",
  "unified-auth": "/unified-auth/static-1.413",
  "navigation-messaging": "/navigation-messaging/static-1.7133",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12033",
  "content-media-compositions": "/content-media-compositions/static-2.16040",
  "idb-keyval": "/idb-keyval/static-1.42",
  "media-bridge-lib": "/media-bridge-lib/static-1.18816",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.694",
  "social-insights-client-types": "/social-insights-client-types/static-1.21892",
  "advanced-menus-core": "/advanced-menus-core/static-1.15029",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11983",
  "ExportDialog": "/ExportDialog/static-6.10334",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33861",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3748",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4094",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3961",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6723",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3542",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3643",
  "persist-promise": "/persist-promise/static-1.3649",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5291",
  "reactive-lib": "/reactive-lib/static-1.662",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.277",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2951",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.41",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.141",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3674",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15028",
  "simple-menus-lib": "/simple-menus-lib/static-1.16545",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3562",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9041",
  "react-flip-move": "/react-flip-move/static-1.68"
}
};
